import * as React from "react";
import type { SVGProps } from "react";
const SvgContract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      transform="translate(2.5 2.5)scale(.9189)"
    >
      <path
        d="M7.292 4.792H3.958M8.958 7.292h-5"
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx={5.208}
        cy={11.042}
        r={1.25}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M14.792 5.216v7.909a2.5 2.5 0 0 1-2.5 2.5H3.125a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5h7.076a2.5 2.5 0 0 1 1.767.732l2.091 2.091a2.5 2.5 0 0 1 .733 1.768"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M14.792 5.208h-2.917c-.92 0-1.667-.746-1.667-1.666V.625"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
export default SvgContract;
